import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { RequestHelper } from "../Helpers/RequestHelper.js";
import { DataDriver } from "../Drivers/DataDriver.js";

// SETTINGS WIDGET
export class Widget {
    /**
     * @param  {string} parentId dom element id
     * @return {void}
     */
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.isAdmin = app.config.isAdmin;
        this.prefixSelector = "#" + this.parentId;
        this.classAtt = "pmdrs-widget";
    }

    init() {
        let $this = this;
        this.addHtml();
        this.initCardCollapse();
        // this.getAPIForm();
        this.addHandlers();

        //GET PM SITE SETTINGS
        this.app.pmdrs.getPmSiteSettings({lendersOptions:1}, (response) => {
            if ($this.generalSettingsEnabled()) {
                $this.siteSettings = JSON.parse(response);
                $this.populateLendersList();
                $this.showElemsIfAdmin();
                $this.hidePilotSettings();
                $this.updateUISettings();
                $this.loadImages();
                $this.hideLoading("settings");
            }
        });
    }

    showLoading(type) {
        document.querySelector(this.app.getSelector("." + type + "-loading")).style.display = "block";
    }

    hideLoading(type) {
        document.querySelector(this.app.getSelector("." + type + "-loading")).style.display = "none";
    }

    showElemsIfAdmin() {
        if (!this.isAdmin) {
            let elemsToHide = ["pmdrs-settings-enable", "pmdrs-settings-show-only-admins", "pmdrs-settings-qc-show-only-admins"];

            elemsToHide.forEach((elem) => {
                document.querySelector(this.app.getSelector("." + elem)).style.display = "none";
            });
        }
    }

    hidePilotSettings() {
        // "Sections unlocked by default" is a pilot feature for bmwmotorcyclesofchulavista only —
        // hidden elsewhere so other dealers don't see/ask about it before it's generally available
        if (this.app.pmdrs.config.accountId !== "bmwmotorcyclesofchulavista") {
            let row = document.querySelector(this.app.getSelector(".pmdrs-sections-unlocked-row"));
            if (row) row.style.display = "none";
        }
    }

    loadImages() {
        let imgChatToAway = document.querySelector(this.app.getSelector("#pmdrs-settings-sms-away-img"));
        let imgVDPDefaultTab = document.querySelector(this.app.getSelector("#pmdrs-settings-default-tab-img"));
        let imgChatNotificationToAway = document.querySelector(this.app.getSelector("#pmdrs-settings-chat-away-img"));

        imgChatToAway.src = this.app.pmdrs.pmApi.getRootURL() + "dist/img/chat-to-away.png";
        imgVDPDefaultTab.src = this.app.pmdrs.pmApi.getRootURL() + "dist/img/vdp-default-tab.png";
        imgChatNotificationToAway.src = this.app.pmdrs.pmApi.getRootURL() + "dist/img/chat.png";
    }

    initCardCollapse() {
        document.querySelectorAll(this.app.getSelector('.pm-settings-card-header')).forEach(header => {
            header.addEventListener('click', () => {
                const body = document.getElementById(header.dataset.card);
                if (!body) return;
                const opening = !body.classList.contains('open');
                body.classList.toggle('open', opening);
                header.classList.toggle('collapsed', !opening);
            });
        });
    }

    // Shows/hides the whole Lenders card based on the chosen Widget Driver, independent of
    // whether the lenders API actually returned anything - see the note at its call sites.
    updateLenderOptionsVisibility() {
        const section = document.querySelector(this.app.getSelector('.pmdrs-lender-options'));
        if (!section) return;
        const driverSelect = document.querySelector(this.app.getSelector('#pmdrs-settings-driver-select'));
        const driver = driverSelect ? driverSelect.value : (this.siteSettings.driver || '');
        section.style.display = driver === 'lenderdesk' ? 'block' : 'none';
    }

    // Vehicle Conditions only has an effect on the LenderDesk quoting path
    // (LenderDeskPaymentCache::updateCacheBySite on the backend) — gated the same way and for
    // the same reason as Lenders above, so a BMW/pixelmotion-driver site's admin doesn't see a
    // setting that wouldn't affect their quotes.
    updateConditionsVisibility() {
        const section = document.querySelector(this.app.getSelector('.pmdrs-conditions'));
        if (!section) return;
        const driverSelect = document.querySelector(this.app.getSelector('#pmdrs-settings-driver-select'));
        const driver = driverSelect ? driverSelect.value : (this.siteSettings.driver || '');
        section.style.display = driver === 'lenderdesk' ? 'block' : 'none';
    }

    populateLendersList() {
      const container = document.querySelector(this.app.getSelector('.pmdrs-lender-options-list'));
      if (!container || !this.siteSettings?.lendersOptions) return;

      const raw = this.siteSettings.lendersOptions;
      if (!Array.isArray(raw) && raw.error) return;
      const list = Array.isArray(raw) ? raw : Object.values(raw);

      if (!list.length) return;

      container.innerHTML = '';

      list.forEach(item => {
        const div = document.createElement('div');
        const label = document.createElement('label');
        const input = document.createElement('input');

        input.type = 'checkbox';
        input.name = 'lenders[]';
        input.value = item.id;

        label.appendChild(input);
        label.append(` ${item.name} (${item.id})`);
        div.appendChild(label);
        container.appendChild(div);

        input.addEventListener('change', () => this.syncLenderPills());
      });

      const search = document.querySelector(this.app.getSelector('.pmdrs-lender-search'));
      if (search) {
        search.addEventListener('input', () => {
          const q = search.value.toLowerCase();
          container.querySelectorAll('div').forEach(div => {
            const text = div.textContent.toLowerCase();
            div.style.display = text.includes(q) ? '' : 'none';
          });
        });
      }
    }

    syncLenderPills() {
      const pillsContainer = document.querySelector(this.app.getSelector('.pmdrs-lender-selected-pills'));
      if (!pillsContainer) return;
      pillsContainer.innerHTML = '';

      const checked = document.querySelectorAll(this.app.getSelector('.pmdrs-lender-options-list input[type="checkbox"]:checked'));
      checked.forEach(input => {
        const pill = document.createElement('span');
        pill.className = 'pmdrs-lender-pill';
        pill.textContent = input.value;

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          input.checked = false;
          this.syncLenderPills();
        });

        pill.appendChild(remove);
        pillsContainer.appendChild(pill);
      });
    }

    updateUISettings() {
        let enableInput = document.querySelector(this.app.getSelector("#pmdrs-settings-enable"));
        let onlyAdminsInput = document.querySelector(this.app.getSelector("#pmdrs-settings-only-admins"));
        let quickChatOnlyAdminsInput = document.querySelector(this.app.getSelector("#pmdrs-settings-quick-chat-only-admins"));
        let defaultTabSelect = document.querySelector(this.app.getSelector("#pmdrs-settings-default-tab-select"));
        let driverSelect = document.querySelector(this.app.getSelector("#pmdrs-settings-driver-select"));
        let phoneNumber = document.querySelector(this.app.getSelector("#phoneNumber"));
        let dealerCode = document.querySelector(this.app.getSelector("#dealerCode"));
        let tradeInEnable = document.querySelector(this.app.getSelector("#pmdrs-tradein-enable"));
        let onlyEasyRide = document.querySelector(this.app.getSelector("#pmdrs-easy-ride-enable"));
        let vlpWidgetType = document.querySelector(this.app.getSelector("#pmdrs-vlp-widget-type"));
        let vlpDefaultPayment = document.querySelector(this.app.getSelector("#pmdrs-vlp-default-payment"));
        let contactFormAtBottom = document.querySelector(this.app.getSelector("#pmdrs-contactform-bottom"));
        let sectionsUnlockedByDefault = document.querySelector(this.app.getSelector("#pmdrs-sections-unlocked"));
        let dontIncludeTaxes = document.querySelector(this.app.getSelector("#pmdrs-donot-include-taxes"));
        let useSheffieldRates = document.querySelector(this.app.getSelector("#pmdrs-use-sheffield-rates"));
        let useMSRPForCalculations = document.querySelector(this.app.getSelector("#pmdrs-use-msrp-for-calculations"));
        let includeEstimatedTradeInValue = document.querySelector(this.app.getSelector("#pmdrs-include-estimatedtradein-value"));
        let onlyButtonOnVDP = document.querySelector(this.app.getSelector("#pmdrs-only-btnvdp-enable"));
        let onlyButtonOnVLP = document.querySelector(this.app.getSelector("#pmdrs-only-btnvlp-enable"));
        let startApplicationButtonEnabled = document.querySelector(this.app.getSelector("#pmdrs-start-application-enable"));
        let startApplicationButtonText = document.querySelector(this.app.getSelector("#startApplicationButtonText"));
        let startApplicationButtonUrl = document.querySelector(this.app.getSelector("#startApplicationButtonUrl"));
        let privacyPolicyUrl = document.querySelector(this.app.getSelector("#privacyPolicyUrl"));
        let CCInFinalPrice = document.querySelector(this.app.getSelector("#pmdrs-cc-in-finalprice"));
        let needSetUp = document.querySelector(this.app.getSelector("#pmdrs-need-setup"));
        let launchDateInput = document.querySelector(this.app.getSelector("#pmdrs-launch-date"));
        let launchWhenLive = document.querySelector(this.app.getSelector("#pmdrs-launch-when-live"));
        let awayMessage = document.querySelector(this.app.getSelector("#pmdrs-away-msg-enable"));
        let hideChat = document.querySelector(this.app.getSelector("#pmdrs-hide-chat-notification"));
        let vlpBtnColor = document.querySelector(this.app.getSelector("#vlp_btn_color"));
        let vlpBtnText = document.querySelector(this.app.getSelector("#vlp_btn_text"));
        let vlpBtnPreview = document.querySelector(this.app.getSelector("#pmdrs-btn-preview-btn"));
        // let tradeInType = document.querySelector(this.app.getSelector("#tradeInType"));

        phoneNumber.value = this.siteSettings.custom_header || "";
        dealerCode.value = this.siteSettings.dealerCode || "";
        enableInput.checked = this.siteSettings.enable;
        onlyAdminsInput.checked = this.siteSettings.onlyAdmins;
        quickChatOnlyAdminsInput.checked = this.siteSettings.quickChatOnlyAdmins;
        tradeInEnable.checked = this.siteSettings.tradeInEnable;
        onlyEasyRide.checked = this.siteSettings.onlyEasyRide;
        driverSelect.value = this.siteSettings.driver || "";
        vlpWidgetType.value = this.siteSettings.vlpWidgetType || (this.siteSettings.useGridWidget ? 'grid' : 'box');
        vlpDefaultPayment.value = this.siteSettings.vlpDefaultPayment || 'lease';
        contactFormAtBottom.checked = this.siteSettings.contactFormAtBottom;
        sectionsUnlockedByDefault.checked = this.siteSettings.sectionsUnlockedByDefault;
        dontIncludeTaxes.checked = this.siteSettings.dontIncludeTaxes;
        useSheffieldRates.checked = this.siteSettings.useSheffieldRates;
        useMSRPForCalculations.checked = this.siteSettings.useMSRPForCalculations;
        includeEstimatedTradeInValue.checked = this.siteSettings.includeEstimatedTradeInValue;
        onlyButtonOnVDP.checked = this.siteSettings.onlyButtonOnVDP;
        onlyButtonOnVLP.checked = this.siteSettings.onlyButtonOnVLP;
        startApplicationButtonEnabled.checked = this.siteSettings.startApplicationButtonEnabled || false;
        startApplicationButtonText.value = this.siteSettings.startApplicationButtonText || "";
        startApplicationButtonUrl.value = this.siteSettings.startApplicationButtonUrl || "";
        privacyPolicyUrl.value = this.siteSettings.privacyPolicyUrl || "";
        CCInFinalPrice.checked = this.siteSettings.customerCashInFinalPrice || false;
        launchWhenLive.checked = this.siteSettings.launchWhenLive || false;
        launchDateInput.value = this.siteSettings.launchDate || "";
        launchDateInput.disabled = launchWhenLive.checked;
        awayMessage.checked = this.siteSettings.awayMessageEnable;
        needSetUp.checked = this.siteSettings.needSetUp;
        vlpBtnColor.value = this.siteSettings.vlp_btn_color;
        vlpBtnText.value = this.siteSettings.vlp_btn_text || "Personalize Deal Now";
        // Defaults to hidden (opt-in to show) when never explicitly set, not the previous
        // implicit-false/shown default.
        hideChat.checked = this.siteSettings.hide_chat_notification ?? true;
        // tradeInType.value = this.siteSettings.tradeInType ?? "manual";
        //lenders
        const lenders = this.siteSettings.lenders || [];
        lenders.forEach(value => {
            const checkbox = document.querySelector(`.pmdrs-lender-options input[type="checkbox"][value="${value}"]`);
            if (checkbox) checkbox.checked = true;
        });
        this.syncLenderPills();
        //payment types
        const ptypes = this.siteSettings.paymentTypes || [];
        ptypes.forEach(value => {
            const checkbox = document.querySelector(`.pmdrs-payment-types input[type="checkbox"][value="${value}"]`);
            if (checkbox) {
                checkbox.checked = true;
            }
        });
        //vehicle conditions — unlike paymentTypes above, this defaults to ALL checked when
        //never explicitly set (matches the backend's default-to-all read pattern)
        const conditions = this.siteSettings.conditions;
        const hasConditions = Array.isArray(conditions) && conditions.length > 0;
        document.querySelectorAll('.pmdrs-conditions-list input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = hasConditions ? conditions.includes(checkbox.value) : true;
        });

        // down payment mode + panels
        const dpMode = this.siteSettings.dpMode || "specific";
        const dpModeInput = document.querySelector(this.app.getSelector("#pmdrs-dp-mode"));
        if (dpModeInput) dpModeInput.value = dpMode;
        this.activateDpTab(dpMode);

        const dpSpecific = document.querySelector(this.app.getSelector("#pmdrs-dp-specific-amount"));
        if (dpSpecific) dpSpecific.value = this.siteSettings.dpSpecificAmount || "";

        const dpPct = document.querySelector(this.app.getSelector("#pmdrs-dp-percentage"));
        if (dpPct) dpPct.value = this.siteSettings.dpPercentage || "";

        const dpCriteria = this.siteSettings.dpCriteria || [];
        dpCriteria.forEach(rule => {
            this.addDownPaymentCriteriaRow(rule.operator, rule.price, rule.amount);
        });


        // load preview btn
        let icon = "<i class='pmdrs-fa pmdrs-fa-shopping-cart' style='margin-right: 8px;'></i>";
        vlpBtnPreview.innerHTML = icon + (this.siteSettings.vlp_btn_text || "Personalize Deal Now");
        vlpBtnPreview.style.backgroundColor = this.siteSettings.vlp_btn_color;

        // Lenders is a LenderDesk-only concept — gated on the chosen driver, not on whether
        // the lenders API happened to return anything (it can legitimately return empty for
        // a real LenderDesk site, e.g. a transient API hiccup, and previously that silently
        // hid the whole section instead of just leaving the checkbox list empty).
        this.updateLenderOptionsVisibility();
        this.updateConditionsVisibility();

        if (this.siteSettings.default_tab) {
            let value = "";
            if (this.siteSettings.default_tab.includes("balloon")) {
                value = "easy ride";
            } else {
                value = this.siteSettings.default_tab;
            }
            defaultTabSelect.value = value;
        }
    }

    generalSettingsEnabled() {
        console.log(this.app.config.vehicle.vin);
        return this.app.config.vehicle.vin == "all";
    }

    addHtml() {
        let $this = this;

        if ($this.generalSettingsEnabled()) {
            document
                .querySelector($this.app.getSelector(""))
                .insertAdjacentHTML("beforeend", `<div class="pmdrs-admin-settings bg-white">

	<div class="pm-settings-header">
		<h3>Speed DRS Settings</h3>
		<span class="success-txt" style="display:none;">✓ Saved</span>
	</div>

	<form method="post" id="pmdrs-settings-form">

		<!-- GENERAL -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header" data-card="pm-card-general">
				<span><i class="pmdrs-fa pmdrs-fa-cog"></i> General</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body open" id="pm-card-general">
				<div class="pmdrs-settings-enable">
					<div class="pm-setting-row">
						<span class="pm-setting-label">DRS Enable</span>
						<label class="pm-settings-toggle">
							<input class="settings-enable" type="checkbox" name="enable" id="pmdrs-settings-enable">
							<span class="pm-toggle-slider"></span>
						</label>
					</div>
				</div>
				<div class="pmdrs-settings-show-only-admins">
					<div class="pm-setting-row">
						<span class="pm-setting-label">Show only to admins</span>
						<label class="pm-settings-toggle">
							<input class="settings-enable" type="checkbox" name="onlyAdmins" id="pmdrs-settings-only-admins">
							<span class="pm-toggle-slider"></span>
						</label>
					</div>
				</div>
				<div class="pmdrs-settings-qc-show-only-admins">
					<div class="pm-setting-row">
						<span class="pm-setting-label">Quick Chat btn only to admins</span>
						<label class="pm-settings-toggle">
							<input class="settings-enable" type="checkbox" name="quickChatOnlyAdmins" id="pmdrs-settings-quick-chat-only-admins">
							<span class="pm-toggle-slider"></span>
						</label>
					</div>
				</div>
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="phoneNumber">Contact Phone Number</label>
					<input type="text" name="custom_header" id="phoneNumber" class="pm-setting-input">
				</div>
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="dealerCode">Dealer Code</label>
					<input type="text" name="dealerCode" id="dealerCode" class="pm-setting-input" placeholder="OEM/franchise dealer code (optional, for embeds)">
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Need Set Up?</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="needSetUp" id="pmdrs-need-setup">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pmdrs-settings-launch-date">
					<div class="pm-setting-row">
						<label class="pm-setting-label" for="pmdrs-launch-date">Launch Date</label>
						<input type="date" name="launchDate" id="pmdrs-launch-date">
					</div>
					<div class="pm-setting-row">
						<span class="pm-setting-label">Launch when site goes Live</span>
						<label class="pm-settings-toggle">
							<input class="settings-enable" type="checkbox" name="launchWhenLive" id="pmdrs-launch-when-live">
							<span class="pm-toggle-slider"></span>
						</label>
					</div>
				</div>
			</div>
		</div>

		<!-- LAYOUT -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header" data-card="pm-card-layout">
				<span><i class="pmdrs-fa pmdrs-fa-th-large"></i> Layout</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body open" id="pm-card-layout">
				<div class="pm-setting-row">
					<span class="pm-setting-label">VLP Widget Type</span>
					<select name="vlpWidgetType" id="pmdrs-vlp-widget-type" class="pm-setting-select">
						<option value="box">Box Widget</option>
						<option value="grid">Grid Widget</option>
						<option value="text">Text Widget</option>
					</select>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Vehicle Listing App Default Payment</span>
					<select name="vlpDefaultPayment" id="pmdrs-vlp-default-payment" class="pm-setting-select">
						<option value="lease">Lease</option>
						<option value="finance">Finance</option>
						<option value="balloon">Balloon</option>
						<option value="cash">Cash</option>
					</select>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Contact form at bottom</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="contactFormAtBottom" id="pmdrs-contactform-bottom">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row pmdrs-sections-unlocked-row">
					<span class="pm-setting-label">Sections unlocked by default</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="sectionsUnlockedByDefault" id="pmdrs-sections-unlocked">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Only Button on VDP</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="onlyButtonOnVDP" id="pmdrs-only-btnvdp-enable">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Only Button on VLP</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="onlyButtonOnVLP" id="pmdrs-only-btnvlp-enable">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Show "Pre-qualify Now" button</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="startApplicationButtonEnabled" id="pmdrs-start-application-enable">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="startApplicationButtonText">Pre-qualify Now Button Text</label>
					<input type="text" name="startApplicationButtonText" id="startApplicationButtonText" class="pm-setting-input" placeholder="Pre-qualify now">
				</div>
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="startApplicationButtonUrl">Pre-qualify Now Button URL (absolute URL or relative path — defaults to /get-pre-approved)</label>
					<input type="text" name="startApplicationButtonUrl" id="startApplicationButtonUrl" class="pm-setting-input" placeholder="/get-pre-approved or https://example.com/apply">
				</div>
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="privacyPolicyUrl">Privacy Policy URL</label>
					<input type="text" name="privacyPolicyUrl" id="privacyPolicyUrl" class="pm-setting-input" placeholder="https://example.com/privacy-policy">
				</div>
			</div>
		</div>

		<!-- PAYMENTS -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header" data-card="pm-card-payments">
				<span><i class="pmdrs-fa pmdrs-fa-credit-card"></i> Payments</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body open" id="pm-card-payments">
				<div class="pm-setting-row">
					<span class="pm-setting-label">Default Tab</span>
					<select id="pmdrs-settings-default-tab-select" name="default_tab" class="pm-setting-select">
						<option>finance</option>
						<option>lease</option>
						<option>easy ride</option>
						<option>cash</option>
						<option>premier</option>
					</select>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Widget Driver</span>
					<select id="pmdrs-settings-driver-select" name="driver" class="pm-setting-select" required>
						<option value="" disabled>Select Driver</option>
						<option value="pixelmotion">pixelmotion</option>
						<option value="lenderdesk">lenderdesk</option>
						<option value="pmrates">pmrates</option>
					</select>
				</div>
				<div class="pm-setting-row pm-setting-row--top">
					<span class="pm-setting-label">Payment Types</span>
					<div class="pm-checkbox-group pmdrs-payment-types">
						<label><input type="checkbox" name="paymentTypes[]" value="finance"> Finance</label>
						<label><input type="checkbox" name="paymentTypes[]" value="lease"> Lease</label>
						<label><input type="checkbox" name="paymentTypes[]" value="balloon"> Balloon</label>
						<label><input type="checkbox" name="paymentTypes[]" value="cash"> Cash</label>
					</div>
				</div>
				<div class="pm-setting-row pm-setting-row--top pmdrs-conditions" style="display:none">
					<span class="pm-setting-label">Vehicle Conditions</span>
					<div class="pm-checkbox-group pmdrs-conditions-list">
						<label><input type="checkbox" name="conditions[]" value="new"> New</label>
						<label><input type="checkbox" name="conditions[]" value="used"> Used</label>
					</div>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">ONLY use Easy-Ride Tab</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="onlyEasyRide" id="pmdrs-easy-ride-enable">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Do Not Include Taxes</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="dontIncludeTaxes" id="pmdrs-donot-include-taxes">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Use Sheffield Rates</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="useSheffieldRates" id="pmdrs-use-sheffield-rates">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Use MSRP for calculations</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="useMSRPForCalculations" id="pmdrs-use-msrp-for-calculations">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Customer Cash in Final Price</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="customerCashInFinalPrice" id="pmdrs-cc-in-finalprice">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<figure class="pm-setting-preview-figure">
					<img src="" alt="default-tab-img" id="pmdrs-settings-default-tab-img">
				</figure>
			</div>
		</div>

		<!-- TRADE-IN -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header" data-card="pm-card-tradein">
				<span><i class="pmdrs-fa pmdrs-fa-exchange-alt"></i> Trade-In</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body open" id="pm-card-tradein">
				<div class="pm-setting-row">
					<span class="pm-setting-label">Trade-In Enable</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="tradeInEnable" id="pmdrs-tradein-enable">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Include Estimated Trade-In Value</span>
					<label class="pm-settings-toggle">
						<input class="settings-enable" type="checkbox" name="includeEstimatedTradeInValue" id="pmdrs-include-estimatedtradein-value">
						<span class="pm-toggle-slider"></span>
					</label>
				</div>
			</div>
		</div>

		<!-- DOWN PAYMENT -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header" data-card="pm-card-dp">
				<span><i class="pmdrs-fa pmdrs-fa-dollar-sign"></i> Down Payment</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body open" id="pm-card-dp">
				<div class="pmdrs-dp-section">
					<input type="hidden" name="dpMode" id="pmdrs-dp-mode" value="specific">
					<ul class="nav nav-tabs pmdrs-dp-tabs">
						<li class="nav-item"><a class="nav-link active" data-tab="specific" href="#">Specific Value</a></li>
						<li class="nav-item"><a class="nav-link" data-tab="percentage" href="#">Percentage</a></li>
						<li class="nav-item"><a class="nav-link" data-tab="criteria" href="#">Criteria</a></li>
					</ul>
					<div class="tab-content pmdrs-dp-tab-content">
						<div class="tab-pane active" id="pmdrs-dp-panel-specific">
							<label>Fixed down payment amount:</label>
							<div class="pmdrs-dp-input-row">
								<span>$</span>
								<input type="number" name="dpSpecificAmount" id="pmdrs-dp-specific-amount" placeholder="e.g. 1000" min="0">
							</div>
						</div>
						<div class="tab-pane" id="pmdrs-dp-panel-percentage">
							<label>Percentage of unit price applied to all vehicles:</label>
							<div class="pmdrs-dp-input-row">
								<input type="number" name="dpPercentage" id="pmdrs-dp-percentage" placeholder="e.g. 10" min="0" max="100">
								<span>%</span>
							</div>
						</div>
						<div class="tab-pane" id="pmdrs-dp-panel-criteria">
							<p class="pmdrs-dp-hint">Set a down payment amount for each unit price range.</p>
							<div class="pmdrs-dp-criteria-list"></div>
							<button type="button" id="pmdrs-add-dp-criteria">+ Add Rule</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- LENDERS (hidden by default, shown via JS for LenderDesk sites) -->
		<div class="pm-settings-card pmdrs-lender-options" style="display:none">
			<div class="pm-settings-card-header" data-card="pm-card-lenders">
				<span><i class="pmdrs-fa pmdrs-fa-university"></i> Lenders</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body open" id="pm-card-lenders">
				<div class="pmdrs-lender-selected-pills"></div>
				<input type="text" class="pmdrs-lender-search" placeholder="Search lenders..." autocomplete="off">
				<div class="pmdrs-lender-options-list"></div>
			</div>
		</div>

		<!-- VLP BUTTON (collapsed by default) -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header collapsed" data-card="pm-card-vlpbtn">
				<span><i class="pmdrs-fa pmdrs-fa-mouse-pointer"></i> VLP / VDP Button</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body" id="pm-card-vlpbtn">
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="vlp_btn_color">Button Color</label>
					<input type="color" name="vlp_btn_color" id="vlp_btn_color">
				</div>
				<div class="pm-setting-row">
					<label class="pm-setting-label" for="vlp_btn_text">Button Text</label>
					<input type="text" name="vlp_btn_text" id="vlp_btn_text" class="pm-setting-input">
				</div>
				<div class="pm-setting-row">
					<span class="pm-setting-label">Preview</span>
					<button type="button" id="pmdrs-btn-preview-btn">
						<i class="pmdrs-fa pmdrs-fa-shopping-cart" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>

		<!-- CHAT / VIDEO (collapsed by default) -->
		<div class="pm-settings-card">
			<div class="pm-settings-card-header collapsed" data-card="pm-card-chat">
				<span><i class="pmdrs-fa pmdrs-fa-comments"></i> Chat / Video</span>
				<i class="pmdrs-fa pmdrs-fa-chevron-down pm-card-arrow"></i>
			</div>
			<div class="pm-settings-card-body" id="pm-card-chat">
				<div class="pmdrs-settings-chat-away">
					<div class="pm-setting-row">
						<span class="pm-setting-label label-text">Hide Video/Chat</span>
						<label class="toggle">
							<input type="checkbox" class="settings-enable" name="hide_chat_notification" id="pmdrs-hide-chat-notification">
							<span class="slider"></span>
						</label>
					</div>
					<figure class="pm-setting-preview-figure">
						<img src="" alt="chat-away" id="pmdrs-settings-chat-away-img">
					</figure>
				</div>
				<div class="pmdrs-settings-sms-away">
					<div class="pm-setting-row">
						<span class="pm-setting-label label-text">Set Chat/Video to Away</span>
						<label class="toggle">
							<input type="checkbox" class="settings-enable" name="awayMessageEnable" id="pmdrs-away-msg-enable">
							<span class="slider"></span>
						</label>
					</div>
					<figure class="pm-setting-preview-figure">
						<img src="" alt="video-chat-to-away" id="pmdrs-settings-sms-away-img">
					</figure>
				</div>
			</div>
		</div>

<div class="pm-settings-footer">
			<button type="submit" class="pm-save-btn">Save Settings</button>
			<div class="settings-loading">
				<div class="lds-dual-ring"></div>
			</div>
		</div>

	</form>
</div>
`);
        }

        DOMHelper.addClass(
            $this.app.getSelector('.pmdrs-admin-settings'),
            `pmdrs-${$this.app.pmdrs.getOEM().toLowerCase()}-settings`
        )
        // if ($this.app.pmdrs.dataDriver.key == DataDriver.PIXELMOTION_KEY) {
        //     $this.addAprIframe();
        // }
    }

    addAprIframe() {
        let isBmw = this.app.pmdrs.getOEM() == "bmwmotorrad";

        //get APR from pm-drs-api
        let data = {
            vin: this.app.config.vehicle.vin,
            showCriteria: false,
            isBmw: false,
        };
        var iframeUrl = this.getIframeURL();
        iframeUrl = RequestHelper.getUrl(iframeUrl, data);
        let iframeHtml = '<iframe src="' + iframeUrl + '"></iframe>';
        document.querySelector(this.app.getSelector("")).insertAdjacentHTML("beforeend", iframeHtml);
    }

    getIframeURL() {
        let isBmw = this.app.pmdrs.getOEM() == "bmwmotorrad";
        let iframeUrl = this.app.pmdrs.pmApi.getURL();

        if (this.generalSettingsEnabled()) {
            iframeUrl +=
                "/ratesheets/getAdminWidget/" +
                this.app.pmdrs.getOEM() +
                "/" +
                this.app.pmdrs.config.accountId +
                "/" +
                isBmw;
        } else {
            iframeUrl += "/ratesheets/createEdit/" + this.app.pmdrs.getOEM() + "/" + this.app.pmdrs.config.accountId;
        }

        return iframeUrl;
    }

    getAPIForm() {
        let $this = this;
        //SUCCESS
        let successCallback = (response) => {
            if (response) {
                // $this.app.config.apr = JSON.parse(response);
                let appSelector = $this.app.getSelector("");
                document.querySelector(appSelector).insertAdjacentHTML("beforeend", response);
                let appElement = document.querySelector(appSelector);
                DOMHelper.exec_body_scripts(appElement);
            }
            // app.init();
        };

        //ERROR
        let errorCallback = () => {
            console.log("error calling getAPRForm");
        };

        //get APR from pm-drs-api
        let data = {
            loadBootstrap: $this.app.config.loadBootstrap,
            vin: "A12345BCD5678",
            showVin: false,
        };
        RequestHelper.ajax(
            "GET",
            $this.app.pmdrs.pmApi.getURL() + "/ratesheets/createEdit/" + $this.app.pmdrs.config.accountId,
            data,
            successCallback,
            errorCallback
        );
    }

    addHandlers() {
        let $this = this;
        //SUBMIT
        let settingsSubmit = function (event) {
            event.preventDefault();
            let data = [];

            if (event.type == "submit") {
                data = new FormData(event.target);
            } else {
                let form = document.querySelector($this.app.getSelector("#pmdrs-settings-form"));
                data = new FormData(form);
            }
            //FORM DATA AS JSON
            // const values = Object.fromEntries(data.entries());
            // console.log(values);
            $this.showLoading("settings");
            $this.app.pmdrs.pmApi.pmSiteSettings.savePmSettings(
                $this.app.pmdrs.config.accountId,
                data,
                (response) => {
                    $this.hideLoading("settings");
                    response = JSON.parse(response);

                    document.querySelector($this.app.getSelector(".success-txt")).style.display = "block";
                    setTimeout(() => {
                        document.querySelector($this.app.getSelector(".success-txt")).style.display = "none";
                    }, 2500);
                }
            );
            return false;
        };

        DOMHelper.addHandler(this.app.getSelector("#phoneNumber"), "keyup", (event) => {
            if (event.target.value != "") {
                event.target.value = FormatHelper.phoneNumberFormat(event.target.value);
            }
        });

        DOMHelper.addHandler(this.app.getSelector("#pmdrs-settings-driver-select"), "change", () => {
            this.updateLenderOptionsVisibility();
            this.updateConditionsVisibility();
        });

        DOMHelper.addHandler(this.app.getSelector("#vlp_btn_color"), "change", (event) => {
            let color = event.target.value;
            let btnPreview = document.querySelector(this.app.getSelector("#pmdrs-btn-preview-btn"));
            btnPreview.style.backgroundColor = color;
        });

        DOMHelper.addHandler(this.app.getSelector("#vlp_btn_text"), "keyup", (event) => {
            let value = event.target.value;
            let icon = "<i class='pmdrs-fa pmdrs-fa-shopping-cart' style='margin-right: 8px;'></i>";

            let btnPreview = document.querySelector(this.app.getSelector("#pmdrs-btn-preview-btn"));
            btnPreview.innerHTML = icon + value;
        });

        DOMHelper.addHandler(this.app.getSelector("#pmdrs-launch-when-live"), "change", (event) => {
            let dateInput = document.querySelector(this.app.getSelector("#pmdrs-launch-date"));
            dateInput.disabled = event.target.checked;
            if (event.target.checked) {
                dateInput.value = "";
            }
        });

        DOMHelper.addHandler(this.app.getSelector("#pmdrs-settings-form"), "submit", settingsSubmit);
        DOMHelper.addHandler(this.app.getSelector("#pmdrs-away-msg-enable"), "change", settingsSubmit);
        DOMHelper.addHandler(this.app.getSelector("#pmdrs-hide-chat-notification"), "change", settingsSubmit);

        DOMHelper.addHandler(this.app.getSelector(".pmdrs-dp-tabs"), "click", (event) => {
            const link = event.target.closest(".nav-link");
            if (!link) return;
            event.preventDefault();
            const tab = link.dataset.tab;
            this.activateDpTab(tab);
            const modeInput = document.querySelector(this.app.getSelector("#pmdrs-dp-mode"));
            if (modeInput) modeInput.value = tab;
        });

        DOMHelper.addHandler(this.app.getSelector("#pmdrs-add-dp-criteria"), "click", () => {
            this.addDownPaymentCriteriaRow();
        });

        DOMHelper.addHandler(this.app.getSelector(".pmdrs-dp-criteria-list"), "click", (event) => {
            if (event.target.classList.contains("pmdrs-remove-dp-row")) {
                event.target.closest(".pmdrs-dp-criteria-row").remove();
            }
        });
    }

    activateDpTab(tab) {
        document.querySelectorAll(this.app.getSelector(".pmdrs-dp-tabs .nav-link")).forEach(link => {
            link.classList.toggle("active", link.dataset.tab === tab);
        });
        document.querySelectorAll(this.app.getSelector(".pmdrs-dp-tab-content .tab-pane")).forEach(pane => {
            pane.classList.remove("active");
        });
        const activePane = document.querySelector(this.app.getSelector(`#pmdrs-dp-panel-${tab}`));
        if (activePane) activePane.classList.add("active");
    }

    addDownPaymentCriteriaRow(operator = "lt", price = "", amount = "") {
        const list = document.querySelector(this.app.getSelector(".pmdrs-dp-criteria-list"));
        if (!list) return;

        const index = list.querySelectorAll(".pmdrs-dp-criteria-row").length;
        const row = document.createElement("div");
        row.className = "pmdrs-dp-criteria-row";
        row.innerHTML = `
            <span>Unit Price</span>
            <select name="dpCriteria[${index}][operator]">
                <option value="lt" ${operator === "lt" ? "selected" : ""}>&lt; (less than)</option>
                <option value="gte" ${operator === "gte" ? "selected" : ""}>&gt;= (greater or equal)</option>
            </select>
            <span>$</span>
            <input type="number" name="dpCriteria[${index}][price]" value="${price}" placeholder="e.g. 10000" min="0">
            <span>&#8594; Down Payment: $</span>
            <input type="number" name="dpCriteria[${index}][amount]" value="${amount}" placeholder="e.g. 1000" min="0">
            <button type="button" class="pmdrs-remove-dp-row">&#x2715;</button>
        `;
        list.appendChild(row);
    }
}